export default __webpack_public_path__ + "static/media/benefits_desc3mx.9786f6e7.png";